import "core-js/modules/es.array.push.js";
export default {
  props: {
    crumb: {
      default: () => [],
      required: true,
      type: Array
    },
    showBackBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getCrumbLabel(item) {
      // 兼容旧的字符串 crumb，同时支持 { label, path } 形式的可点击 crumb。
      return typeof item === "string" ? item : item.label || item.title || "";
    },
    getCrumbKey(item, index) {
      // 对象 crumb 不能直接作为 key，避免多个对象都变成 [object Object]。
      return `${index}-${this.getCrumbLabel(item)}`;
    },
    isCrumbClickable(item, index) {
      // 第一级是模块入口，最后一级是当前页，这两端都不参与点击跳转。
      if (index === 0 || index >= this.crumb.length - 1) return false;
      if (typeof item !== "string" && (item.path || item.to)) return true;
      return typeof item === "string" && index === this.crumb.length - 2;
    },
    /**
     * 处理面包屑点击事件
     * @param {Object|string} item - 面包屑项对象或字符串
     * @param {number} index - 面包屑项的索引
     */
    handleCrumbClick(item, index) {
      // 检查当前面包屑项是否可点击，如果不可点击则直接返回
      if (!this.isCrumbClickable(item, index)) return;

      // 判断目标路径，如果是字符串类型则目标为null，否则获取to或path属性
      const target = typeof item === "string" ? null : item.to || item.path;
      // 如果存在目标路径，则进行路由跳转
      if (target) {
        this.$router.push(target);
        return;
      }
      if (this.$listeners && this.$listeners["crumb-click"]) {
        // 同页切换列表/新增/编辑的页面会监听 crumb-click，自行处理返回逻辑，不再强制 router.back。
        this.$emit("crumb-click", {
          item,
          index,
          label: this.getCrumbLabel(item),
          crumb: this.crumb
        });
        return;
      }

      // 旧字符串 crumb 没有路径信息时，只支持点击上一级返回。
      this.$router.back();
    }
  }
};